/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Empty_DescInputs */

const en_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I can tell you about Sohan's skills, experience, projects, and how to get in touch.`)
};

const ar_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنني إخبارك عن مهارات سوهان وخبرته ومشاريعه وكيفية التواصل معه.`)
};

const bn_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সোহানের দক্ষতা, অভিজ্ঞতা, প্রজেক্ট আর যোগাযোগের উপায় সম্পর্কে জানতে চাইলে আমাকে জিজ্ঞেস করুন।`)
};

const de_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich kann Ihnen mehr über Sohans Fähigkeiten, Erfahrung, Projekte und Kontaktmöglichkeiten erzählen.`)
};

const es_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedo contarte sobre las habilidades, experiencia, proyectos y formas de contacto de Sohan.`)
};

const fr_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je peux vous parler des compétences, de l’expérience, des projets et des coordonnées de Sohan.`)
};

const pt_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso contar sobre as habilidades, experiência, projetos e formas de contato do Sohan.`)
};

const zh_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以向您介绍 Sohan 的技能、经验、项目以及如何取得联系。`)
};

const tr_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size Sohan'ın becerilerini, deneyimlerini, projelerini ve nasıl iletişime geçeceğinizi anlatabilirim.`)
};

const ru_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я могу рассказать вам о навыках, опыте, проектах Сохана и о том, как с ним связаться.`)
};

const pl_chat_empty_desc = /** @type {(inputs: Chat_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mogę opowiedzieć o umiejętnościach, doświadczeniu i projektach Sohana oraz o tym, jak się z nim skontaktować.`)
};

/**
* | output |
* | --- |
* | "I can tell you about Sohan's skills, experience, projects, and how to get in touch." |
*
* @param {Chat_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_empty_desc = /** @type {((inputs?: Chat_Empty_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Empty_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_empty_desc(inputs)
	if (locale === "bn") return bn_chat_empty_desc(inputs)
	if (locale === "de") return de_chat_empty_desc(inputs)
	if (locale === "es") return es_chat_empty_desc(inputs)
	if (locale === "fr") return fr_chat_empty_desc(inputs)
	if (locale === "pt") return pt_chat_empty_desc(inputs)
	if (locale === "zh") return zh_chat_empty_desc(inputs)
	if (locale === "tr") return tr_chat_empty_desc(inputs)
	if (locale === "ru") return ru_chat_empty_desc(inputs)
	if (locale === "pl") return pl_chat_empty_desc(inputs)
	return en_chat_empty_desc(inputs)
});